export default __webpack_public_path__ + "static/media/ArrowDarkBlue.e80903f9.svg";